<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="disasterTypeOptions">{{ $t('disaster_type') }}</label>
                        <Dropdown
                            v-model="disasterTypeSelected"
                            :options="disasterTypeOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="disasterTypeOptions">
                                <div v-if="disasterTypeOptions.value">
                                    <div>{{ disasterTypeOptions.value.system_name }}</div>
                                </div>
                                <span v-else>
                                    {{ disasterTypeOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="disasterTypeOptions">
                                <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="riskLevelSelected">{{ $t('disaster_level') }}</label>
                        <Dropdown
                            v-model="riskLevelSelected"
                            :options="riskLevelOptions"
                            optionLabel="risklevel_number"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="riskLevelOptions">
                                <div v-if="riskLevelOptions.value">
                                    <div>{{ riskLevelOptions.value.risklevel_number }}</div>
                                </div>
                                <span v-else>
                                    {{ riskLevelOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="riskLevelOptions">
                                <div>{{ riskLevelOptions.option.risklevel_number }}</div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_1_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_search', 'Button')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_1_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_search', 'Button')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchRiskLevel()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="riskLevel_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? riskLevel_table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                dataKey="risklevel_id"
                ref="dt"
                :exportFilename="`ข้อมูลระดับความเสี่ยง-${date}`"
                :sortOrder="1"
                sortField="index"
                :rowHover="true"
                :selection.sync="selectedRiskLevel"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="riskLevelModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedRiskLevel && selectedRiskLevel.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left" >
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/4 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>
                            <!-- Doe ค้นหา  1/4 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedRiskLevel.length === riskLevel_table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedRiskLevel.some((item) => item.risklevel_id === slotProps.data.risklevel_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div style="text-align: center" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_system_name == true">
                    <Column
                        field="system_name"
                        :header="$t('disaster_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_system_name == true">
                                {{ dataTable.data.system_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_risklevel_number == true">
                    <Column
                        field="risklevel_number"
                        :header="$t('disaster_level')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_risklevel_number == true">
                                <div v-if="dataTable.data.risklevel_number == '1'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#00BFFF',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.risklevel_number == '2'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#006400',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.risklevel_number == '3'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FFFF00',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.risklevel_number == '4'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FF8C00',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.risklevel_number == '5'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FE0000',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                                <div v-else class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#A09B9B',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px',
                                            textAlign: 'center'
                                        }"
                                    >
                                        {{ dataTable.data.risklevel_number }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_risklevel_detail == true">
                    <Column
                        field="risklevel_detail"
                        :header="$t('description')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_risklevel_detail == true">
                                <div v-if="dataTable.data.risklevel_detail == ''">-</div>
                                <div v-else>{{ dataTable.data.risklevel_detail }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_risklevel_detail ||
                        columns_index ||
                        columns_system_name ||
                        columns_risklevel_number ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            riskLevelModal = true;
                                            editData(dataTable.data.risklevel_id);
                                            temp = dataTable.data.risklevel_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.risklevel_id;
                                            alertDisplay(temp);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!-- v-if="loadingCreate" -->
        <!-- Manage data -->
        <Dialog :modal="true" :visible.sync="riskLevelModal" :style="{ width: '700px' }" :closable="loadingCreate ? false : true" :header="header">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate" style="top: 30%">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('irl_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-8 p-mt-2">
                            <label for="irl_disaster">{{ $t('disaster_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="irl_disasterTypeSelected"
                                :options="disasterTypeOptions"
                                optionLabel="system_name"
                                :class="{
                                    'p-invalid': error_irl_disasterTypeSelected && !irl_disasterTypeSelected
                                }"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterTypeOptions">
                                    <div v-if="disasterTypeOptions.value">
                                        <div>{{ disasterTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterTypeOptions">
                                    <div>{{ disasterTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_irl_disasterTypeSelected && !irl_disasterTypeSelected">{{
                                $t('irl_disasterSelected_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-4">
                            <label for="irl_riskLevel">{{ $t('disaster_level') }} <span class="required-input">*</span></label>
                            <InputNumber
                                id="irl_riskLevel"
                                v-model="irl_riskLevel"
                                :useGrouping="false"
                                required="true"
                                :class="{ 'p-invalid': error_irl_riskLevel && !irl_riskLevel }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_2', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_irl_riskLevel && !irl_riskLevel">{{ $t('irl_riskLevel_validate') }}</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="irl_description">{{ $t('description') }}</label>
                            <InputText
                                id="irl_description"
                                type="text"
                                v-model="irl_description"
                                required="true"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'InputNumber')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'InputNumber')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8 -->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_3"
                    @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_3"
                    @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="saveData()"
                    ref="TextBox_4"
                    @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'InputNumber')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-risk-level',
    components: {
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            temp: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/4
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/4 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            header: this.$i18n.t('irl_modal_title_add'),
            selectedData: '',
            riskLevel_table: [],
            filters: {},
            selectedRiskLevel: [],

            disasterTypeOptions: [],
            disasterTypeSelected: null,

            riskLevelOptions: [],
            riskLevelSelected: null,

            riskLevelModal: false,
            irl_disasterTypeSelected: null,
            irl_riskLevel: null,
            irl_description: '',

            error_irl_disasterTypeSelected: false,
            error_irl_riskLevel: false,

            displayConfirmation: false,
            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            loading: false,

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'ระดับ',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลระดับความเสี่ยง',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 15,
            PDF_FontBodyVer: 12,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 }
                // risklevel_number:{halign: 'center',
                //                   valign: 'middle',}
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ประเภทสารธารณภัย', dataKey: 'system_name' },
                { title: 'ระดับ', dataKey: 'risklevel_number' },
                { title: 'คำอธิบาย', dataKey: 'risklevel_detail' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_system_name: true,
            columns_risklevel_number: true,
            columns_risklevel_detail: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,

            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const fill_row_detail = [
                            {
                                name_row: 'risklevel_number',
                                detail_row: [
                                    {
                                        check_text: '1',
                                        fill_color: [0, 144, 42]
                                    },
                                    {
                                        check_text: '2',
                                        fill_color: [146, 209, 79]
                                    },
                                    {
                                        check_text: '3',
                                        fill_color: [252, 252, 37]
                                    },
                                    {
                                        check_text: '4',
                                        fill_color: [254, 123, 0]
                                    },
                                    {
                                        check_text: '5',
                                        fill_color: [254, 0, 0]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const fill_row_detail = [
                            {
                                name_row: 'risklevel_number',
                                detail_row: [
                                    {
                                        check_text: '1',
                                        fill_color: [0, 144, 42]
                                    },
                                    {
                                        check_text: '2',
                                        fill_color: [146, 209, 79]
                                    },
                                    {
                                        check_text: '3',
                                        fill_color: [252, 252, 37]
                                    },
                                    {
                                        check_text: '4',
                                        fill_color: [254, 123, 0]
                                    },
                                    {
                                        check_text: '5',
                                        fill_color: [254, 0, 0]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async riskLevelModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.irl_disasterTypeSelected != null &&
                    this.irl_riskLevel != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.riskLevelModal = false;
                            this.clearData();
                        } else {
                            this.riskLevelModal = true;
                        }
                    });
                } else {
                    this.clearData();

                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;
                }
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterTypeOptions = response.data.data;
                    });
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.riskLevelModal = true;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.riskLevel_table = [];
            } else {
                this.riskLevel_table = this.cloneTable;
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate risklevel") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลระดับความเสี่ยงไม่สำเร็จ",
        //     //   detail: "มีข้อมูลระดับความเสี่ยงนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลระดับความเสี่ยงไม่สำเร็จ",
        //           text: "มีข้อมูลระดับความเสี่ยงนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลระดับความเสี่ยง",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลระดับความเสี่ยง",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedRiskLevel.map((item) => ({
                    risklevel_id: item.risklevel_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/risklevel?user=${userId}`, {
                    body: {
                        topic: 'edit-risklevel_date_multiple',
                        selectedRiskLevel: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.riskLevelModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลระดับความเสี่ยงจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchRiskLevel();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedRiskLevel = [...this.riskLevel_table];
            } else {
                this.selectedRiskLevel = [];
            }
            this.$emit('selectedRiskLevel', this.selectedRiskLevel);
            // console.log('selectedRiskLevel', this.selectedRiskLevel);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedRiskLevel.some((item) => item.risklevel_id === row.risklevel_id)) {
                    this.selectedRiskLevel.push(row);
                }
            } else {
                this.selectedRiskLevel = this.selectedRiskLevel.filter((item) => item.risklevel_id !== row.risklevel_id);
            }
            this.$emit('selectedRiskLevel', this.selectedRiskLevel);
            // console.log('selectedRiskLevel', this.selectedRiskLevel);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_2_search')) {
                    this.searchRiskLevel();
                }
            } else if (ModalName === 'Modal_Main') {
                if (!this.isFocused('TextBox_3') && !this.isFocused('TextBox_4')) {
                    this.saveData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: { topic: 'get-level-option' }
                })
                .then((response) => {
                    (this.riskLevelOptions = response.data.data),
                        this.riskLevelOptions.splice(0, 0, {
                            risklevel_number: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.riskLevel_table !== []) {
                    this.riskLevel_table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_system_name ? item.system_name.includes(this.filter) : '') ||
                            (this.columns_risklevel_number ? item.risklevel_number.includes(this.filter) : '') ||
                            (this.columns_risklevel_detail ? item.risklevel_detail.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.riskLevel_table.length; i++) {
                        this.riskLevel_table[i]['index'] = i + 1;
                    }
                } else {
                    this.riskLevel_table = [...this.cloneTable];
                    for (let i = 0; i < this.riskLevel_table.length; i++) {
                        this.riskLevel_table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: { topic: 'get-level-option' }
                })
                .then((response) => {
                    (this.riskLevelOptions = response.data.data),
                        this.riskLevelOptions.splice(0, 0, {
                            risklevel_number: this.$i18n.t('selectAll')
                        });
                });
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: {
                        topic: 'get-table',
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.riskLevel_table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    for (let i = 0; i < this.riskLevel_table.length; i++) {
                        this.riskLevel_table[i]['index'] = i + 1;
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.riskLevel_table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.riskLevel_table = this.cloneTable;
            } else {
                this.riskLevel_table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].risklevel_detail == null || data[index].risklevel_detail == 'null' || data[index].risklevel_detail == '') {
                    data[index].risklevel_detail = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            this.riskLevelModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        async searchRiskLevel() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: {
                        topic: 'search-table',
                        disaster_id: this.disasterTypeSelected,
                        level: this.riskLevelSelected,
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.riskLevel_table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    for (let i = 0; i < this.riskLevel_table.length; i++) {
                        this.riskLevel_table[i]['index'] = i + 1;
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.riskLevel_table);

                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ
            if (this.columns_disabled == true) {
                this.riskLevel_table = this.cloneTable;
            } else {
                this.riskLevel_table = [];
            }

            this.search();
            this.loading = false;
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.disasterTypeSelected !== null || this.riskLevelSelected !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterTypeSelected !== null) {
                        element.textShow = this.disasterTypeSelected.system_name;
                    }
                    if (element.DataName === 'ระดับ' && this.riskLevelSelected !== null) {
                        element.textShow = this.riskLevelSelected.risklevel_number;
                    }
                }
                this.text_Footer = true;
            }
        },

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();

            // console.log('this.checkToken() = ', this.checkToken());

            this.displayConfirmation = false;

            await this.axios
                .post(`${this.$url_service}/initial/risklevel?user=${userId}`, {
                    body: {
                        topic: 'delete-risk-level',
                        id: this.temp
                    }
                })
                .then(() => {
                    // this.initialData();
                    this.searchRiskLevel();
                });
            // this.$toast.add({
            //   severity: "success",
            //   summary: "ลบข้อมูลสำเร็จ",
            //   detail: "ข้อมูลระดับความเสี่ยง",
            //   life: 3000,
            // });
            this.$fire({
                type: 'success',
                title: 'ลบข้อมูลสำเร็จ',
                text: 'ข้อมูลระดับความเสี่ยง',
                timer: 3000,
                confirmButtonColor: '#28B463'
            });
        },

        async saveData() {
            //Check null value
            if (this.irl_disasterTypeSelected == null || this.irl_riskLevel == null) {
                if (this.irl_disasterTypeSelected == null) {
                    this.error_irl_disasterTypeSelected = true;
                }
                if (this.irl_riskLevel == null) {
                    this.error_irl_riskLevel = true;
                }
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userId = this.getUsername();
                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

                    await this.axios
                        .post(`${this.$url_service}/initial/risklevel?user=${userId}`, {
                            body: {
                                topic: 'add-risk-level',
                                userOrg,
                                disaster_id: this.irl_disasterTypeSelected.system_id,
                                level: this.irl_riskLevel,
                                detail: this.irl_description
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // this.initialData();
                                this.searchRiskLevel();

                            // โหลดเพิ่มแก้ไข 5/8
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 5/8 จบ

                            // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                            // console.log("this.check_duplicate ",this.check_duplicate)
                            if (this.check_duplicate == 'duplicate risklevel') {
                                this.$fire({
                                    type: 'error',
                                    title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                    text: 'มีข้อมูลนี้ในระบบแล้ว',
                                    timer: 3000,
                                    confirmButtonColor: '#d33'
                                });
                            } else {
                                this.$fire({
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลระดับความเสี่ยง',
                                    type: 'success',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                        });
                    // console.log("Save data");
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.riskLevelModal = false;
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ

                    const userId = this.getUsername();

                    await this.axios
                        .post(`${this.$url_service}/initial/risklevel?user=${userId}`, {
                            body: {
                                topic: 'edit-risk-level',
                                id: this.temp,
                                disaster_id: this.irl_disasterTypeSelected.system_id,
                                level: this.irl_riskLevel,
                                detail: this.irl_description
                            }
                        })
                        .then(() => {
                            // this.initialData();
                            this.searchRiskLevel();
                        });
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: `ข้อมูลระดับความเสี่ยง ประเภท ${this.irl_disasterTypeSelected.system_name}`,
                    //   life: 3000,
                    // });
                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: `ข้อมูลระดับความเสี่ยง ประเภท ${this.irl_disasterTypeSelected.system_name}`,
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    // console.log("Edit data");
                    this.riskLevelModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }
            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('irl_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: {
                        topic: 'showone-risk-level',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        (this.irl_disasterTypeSelected = {
                            system_id: response.data.data.disaster_id,
                            system_name: response.data.data.system_name
                        }),
                        (this.irl_riskLevel = Number(response.data.data.risklevel_number)),
                        (this.irl_description = response.data.data.risklevel_detail);

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('irl_modal_title_add');
                this.temp = null;
                this.selectedData = '';
                this.displayConfirmation = false;
                this.riskLevelModal = false;
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.irl_disasterTypeSelected = null;
            this.irl_riskLevel = null;
            this.irl_description = '';
            this.error_irl_disasterTypeSelected = false;
            this.error_irl_riskLevel = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.disasterTypeSelected = null;
            this.riskLevelSelected = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },
        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.disasterTypeSelected = null;
                this.riskLevelSelected = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.initialData();
            } else {
                // console.log("25")
                this.disasterTypeSelected = null;
                this.riskLevelSelected = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length == 1) {
                this.PDF_BodySizeSelect = {};
                this.PDF_BodySizeHorSelect = {};
            } else {
                this.PDF_minCellWidthVer = 70;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 70;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_system_name = false;
                this.columns_risklevel_number = false;
                this.columns_risklevel_detail = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'risklevel_number') {
                        this.columns_risklevel_number = true;
                    } else if (!getData.includes('risklevel_number')) {
                        this.columns_risklevel_number = false;
                    }

                    if (element == 'risklevel_detail') {
                        this.columns_risklevel_detail = true;
                    } else if (!getData.includes('risklevel_detail')) {
                        this.columns_risklevel_detail = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
